import type { Schema } from 'yup';
import { ValidationError } from 'yup';
import { isNotUndefined } from '@wistia/type-guards';
import type { FormErrors } from './Form';

export const validateWithYup = <T,>(schema: Schema<T>) => {
  return (data: object) => {
    const parsed = schema.cast(data, { assert: false });
    try {
      schema.validateSync(parsed, { abortEarly: false });
      return {};
    } catch (err: unknown) {
      if (err instanceof ValidationError) {
        // Extract field errors into { field: error } format
        return err.inner.reduce<FormErrors<T>>((acc, error: ValidationError) => {
          if (isNotUndefined(error.path)) {
            acc[error.path as keyof T] = error.message;
            return acc;
          }

          return acc;
        }, {});
      }
      throw err; // If unexpected error, rethrow
    }
  };
};
